import { Tag, Tooltip } from "antd"
import { useTranslation } from "react-i18next"

import { SignedRecordTag } from "../../../Files/components/SignedRecordTag.tsx"
import type { Contract } from "../../types/types.ts"

/** Says when a signed contract has no EZBuild audit trail behind it; a contract signed here needs no words. */
export function SignatureOriginTag({ origin }: { origin: Contract["signature_origin"] }) {
  const { t } = useTranslation()
  if (origin === "external") return <SignedRecordTag signedOutside />
  if (origin === "attested") {
    return (
      <Tooltip title={t("esign.external.attestedTooltip")}>
        <Tag color="gold" className="!m-0" data-testid="signature-attested-tag">
          {t("esign.external.attested")}
        </Tag>
      </Tooltip>
    )
  }
  return null
}
